import type { Collection } from '@/app/actions/collection';
import type { AnswerType } from '~/model/AnswerType';
import type { CommentType } from '~/model/CommentType';
import type { ConclusionType } from '~/model/ConclusionType';
import type { InteractionType } from '~/model/InteractionType';
import type { QuestionReconstructedType, QuestionType } from '~/model/QuestionType';
import type { ResultsType } from '~/model/ResultsType';
import type { SectionType } from '~/model/SectionType';
import type { TimeSlotType } from '~/model/TimeSlotType';
import { useState } from 'react';
import { getResultsData } from '@/app/actions/server';

export function useForm({
  interaction: baseInteraction,
  questions: baseQuestions,
  sections: baseSections,
  conclusions: baseConclusions,
  timeslots,
}: {
  interaction: InteractionType;
  questions?: Array<QuestionType | QuestionReconstructedType>;
  sections: Array<SectionType>;
  conclusions?: Collection<ConclusionType>;
  timeslots?: Collection<TimeSlotType>;
}) {
  const [interaction, setInteraction] = useState(baseInteraction);
  const [sections, setSections] = useState(baseSections);
  const [questions, setQuestions] = useState(baseQuestions);
  const [conclusions, setConclusions] = useState(baseConclusions?.['hydra:member']);
  const [comments, setComments] = useState<Array<{
    [x: number]: Collection<AnswerType & CommentType>;
  }>>();
  const [results, setResults] = useState<ResultsType>();

  const fetchResults = async () => {
    const { comments, questions, results } = await getResultsData(interaction.id);

    setComments(comments);
    setQuestions(questions);
    setResults(results);
  };

  return {
    comments,
    conclusions,
    interaction,
    questions,
    results,
    sections,
    timeslots,
    fetchResults,
    setConclusions,
    setInteraction,
    setQuestions,
    setSections,
  };
};
